export { default } from '@relo/sports-components/es/Checkbox';
export * from '@relo/sports-components/es/Checkbox';
